/**
 * Migration Script: Flat → Team-based structure
 * 
 * Copies root collections into teams/{teamId}/subcollections.
 * This does NOT delete root collections (kept as backup).
 */
import { collection, getDocs, doc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

export async function runMigration(adminUserId, targetTeamId) {
    console.log('🔄 Migration эхэлж байна... teamId:', targetTeamId);
    const results = { schedules: 0, meetings: 0, ordinations: 0, invitations: 0, users: 0 };

    if (!targetTeamId) {
        return { success: false, error: 'teamId байхгүй байна' };
    }

    try {
        // 1. Ensure team doc exists with all required fields
        console.log('1️⃣ Team doc шинэчилж байна...');
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        let inviteCode = '';
        for (let i = 0; i < 6; i++) inviteCode += chars[Math.floor(Math.random() * chars.length)];
        
        await setDoc(doc(db, 'teams', targetTeamId), {
            name: 'Багшийн туслах',
            inviteCode: inviteCode,
            migrated: true,
            migratedAt: serverTimestamp(),
        }, { merge: true });

        // 2. Copy schedules
        console.log('2️⃣ Schedules хуулж байна...');
        const schedulesSnap = await getDocs(collection(db, 'schedules'));
        for (const docSnap of schedulesSnap.docs) {
            await setDoc(
                doc(db, 'teams', targetTeamId, 'schedules', docSnap.id),
                docSnap.data()
            );
            results.schedules++;
        }
        console.log(`   ✅ ${results.schedules} schedules хуулагдлаа`);

        // 3. Copy meetingRequests
        console.log('3️⃣ MeetingRequests хуулж байна...');
        const meetingsSnap = await getDocs(collection(db, 'meetingRequests'));
        for (const docSnap of meetingsSnap.docs) {
            await setDoc(
                doc(db, 'teams', targetTeamId, 'meetingRequests', docSnap.id),
                docSnap.data()
            );
            results.meetings++;
        }
        console.log(`   ✅ ${results.meetings} meetingRequests хуулагдлаа`);

        // 4. Copy ordinationRequests
        console.log('4️⃣ OrdinationRequests хуулж байна...');
        const ordinationsSnap = await getDocs(collection(db, 'ordinationRequests'));
        for (const docSnap of ordinationsSnap.docs) {
            await setDoc(
                doc(db, 'teams', targetTeamId, 'ordinationRequests', docSnap.id),
                docSnap.data()
            );
            results.ordinations++;
        }
        console.log(`   ✅ ${results.ordinations} ordinationRequests хуулагдлаа`);

        // 5. Copy invitations
        console.log('5️⃣ Invitations хуулж байна...');
        const invitationsSnap = await getDocs(collection(db, 'invitations'));
        for (const docSnap of invitationsSnap.docs) {
            await setDoc(
                doc(db, 'teams', targetTeamId, 'invitations', docSnap.id),
                docSnap.data()
            );
            results.invitations++;
        }
        console.log(`   ✅ ${results.invitations} invitations хуулагдлаа`);

        // 6. Update all existing users with teamId (that don't have one)
        console.log('6️⃣ Users шинэчилж байна...');
        const usersSnap = await getDocs(collection(db, 'users'));
        let memberCount = 0;
        for (const userDoc of usersSnap.docs) {
            const userData = userDoc.data();
            // Count existing team members
            if (userData.teamId === targetTeamId) {
                memberCount++;
                continue;
            }
            // Assign teamless users with existing roles to this team
            if (!userData.teamId && userData.role && userData.role !== 'pending') {
                const isOwner = userDoc.id === adminUserId;
                await updateDoc(doc(db, 'users', userDoc.id), {
                    teamId: targetTeamId,
                    teamRole: isOwner ? 'owner' : (userData.role === 'admin' ? 'admin' : 'member'),
                });
                memberCount++;
                results.users++;
            }
        }
        console.log(`   ✅ ${results.users} users шинэчлэгдлэа`);

        // Update member count
        await setDoc(doc(db, 'teams', targetTeamId), {
            memberCount: memberCount,
        }, { merge: true });

        console.log('🎉 Migration амжилттай дууслаа!', results);
        return { success: true, results };
    } catch (err) {
        console.error('❌ Migration алдаа:', err);
        return { success: false, error: err.message };
    }
}
